import { css } from '@emotion/react';
import { colors, thematicColors } from '@revenuemarket/design';
import { ArrowNorthEast } from '@revenuemarket/ui/Icon';
import { LandingTypography } from '@revenuemarket/ui/Typography';
import Link from 'next/link';

export const UnderMinimumPayout = ({
  payoutLimit,
  isMobile,
}: {
  isMobile: boolean;
  payoutLimit: number;
}) => {
  return (
    <div style={{ textAlign: 'center', marginTop: '173px' }}>
      <LandingTypography variant={isMobile ? 'h5' : 'h3'} color={colors.grayscale400}>
        지금은 예상 한도가 발생하지 않았습니다
      </LandingTypography>
      <LandingTypography
        variant={isMobile ? 'h6' : 'h5'}
        color={colors.grayscale400}
        css={css`
          margin-top: 24px;
        `}
      >
        회사 보유 현금 또는 월 평균 번이 개선되면
        <br />{' '}
        <span style={{ color: colors.grayscaleWhite }}>
          약 {payoutLimit.toLocaleString()} 원까지 한도가 발생할 수 있어요
        </span>
      </LandingTypography>

      <LandingTypography
        variant={isMobile ? 'h6' : 'h5'}
        color={colors.grayscale400}
        style={{ marginTop: 24 }}
      >
        (판매 기간<sup>1</sup> 6개월, 연 할인율<sup>2</sup> 8% 적용)
      </LandingTypography>
    </div>
  );
};

export const UnderYearlyRevenue = ({ isMobile }: { isMobile: boolean }) => {
  return (
    <div style={{ textAlign: 'center', marginTop: '171px' }}>
      <LandingTypography variant={isMobile ? 'h5' : 'h3'} color={colors.grayscale400}>
        지금은 예상 한도가 발생하지 않았습니다
      </LandingTypography>
      <LandingTypography
        variant={isMobile ? 'h6' : 'h5'}
        color={colors.grayscale400}
        css={css`
          margin-top: 24px;
        `}
      >
        클로브 금융은 최근 12개월 매출액이 {isMobile ? <br /> : null} 최소 5억 원 이상일 때 이용할
        수 있어요
      </LandingTypography>
      <Link
        target="_blank"
        href="https://intercom.help/clobe/ko/articles/8847464-레베뉴마켓-이용-및-판매-조건-안내"
      >
        <LandingTypography
          variant={isMobile ? 'h8' : 'h6'}
          color={thematicColors.secondary.light}
          css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 8px;

            svg {
              margin-left: 4px;
            }

            svg > path {
              fill: #aab3fa;
            }
          `}
        >
          클로브 금융 최소 이용 조건 가이드
          <ArrowNorthEast width={20} height={20} fill={thematicColors.secondary.light} />
        </LandingTypography>
      </Link>
    </div>
  );
};

export const EstimatedLimit = ({
  company,
  tradingPeriod,
  maxPayoutLimit,
  minPayoutLimit,
  isMobile,
}: {
  isMobile: boolean;
  company: string;
  tradingPeriod: number;
  minPayoutLimit: number;
  maxPayoutLimit: number;
}) => {
  return (
    <div style={{ marginTop: '124px', textAlign: 'center' }}>
      <LandingTypography variant={isMobile ? 'h5' : 'h3'} color={colors.grayscale400}>
        {company}의 예상 한도는
        <br />
        <span
          style={{
            color: 'black',
          }}
        >
          최소 {minPayoutLimit.toLocaleString()} ~ <br />
          최대 {maxPayoutLimit.toLocaleString()} 원입니다
        </span>
      </LandingTypography>
      <LandingTypography variant={isMobile ? 'h6' : 'h5'} color={'black'} style={{ marginTop: 24 }}>
        (판매 기간<sup>1</sup> {tradingPeriod}개월, 연 할인율<sup>2</sup> 8~16% 적용)
      </LandingTypography>
    </div>
  );
};
